var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("dashboard-bi::board-management::角色选择"),
        visible: _vm.showRole,
        width: "690px",
        "destroy-on-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.showRole = $event
        },
      },
    },
    [
      _c("el-transfer", {
        staticClass: "boardManage--dialog__transfer",
        attrs: {
          filterable: "",
          "filter-placeholder": _vm.$t(
            "dashboard-bi::board-management::select-folder-holder"
          ),
          titles: [
            _vm.$t("dashboard-bi::board-management::角色列表"),
            _vm.$t("dashboard-bi::board-management::已选角色"),
          ],
          data: _vm.undistribution,
          props: { key: "roleId", label: "roleName" },
        },
        model: {
          value: _vm.distribution,
          callback: function ($$v) {
            _vm.distribution = $$v
          },
          expression: "distribution",
        },
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.showRole = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.submit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }